import script from "./ImageBackgroundSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageBackgroundSection.vue?vue&type=script&setup=true&lang=js"

import "./ImageBackgroundSection.vue?vue&type=style&index=0&id=b20fdc0c&lang=css"

const __exports__ = script;

export default __exports__